import Vue from 'vue'

import Vuex from 'vuex'
Vue.use(Vuex)

import App from './App.vue'
import router from './router'
import store from './store'
import config from './config'

import Snotify, { SnotifyPosition } from 'vue-snotify';
const options = {
	toast: {
		position: SnotifyPosition.rightTop,
		timeout: 2000
	}
}
Vue.use(Snotify, options)

//import VueResource from 'vue-resource'
//Vue.use(VueResource)
//Vue.http.options.emulateJSON = true;
//Vue.http.options.emulateHTTP = true;

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'
Vue.use(Chartkick.use(Chart))

import VueGoogleCharts from 'vue-google-charts'
Vue.use(VueGoogleCharts)

import VueSocketIO from 'vue-socket.io'
import SocketIO from "socket.io-client"

import vClickOutside from 'v-click-outside';
Vue.use(vClickOutside);
//export const SocketInstance = SocketIO(config.SOCKETIO_ISYSTEM.DEV);
//Vue.use(VueSocketIO, SocketInstance)

Vue.use(new VueSocketIO({
	debug: false,
	connection: config.SOCKETIO_ISYSTEM.DEV,
	vuex: {
		store,
		actionPrefix: 'socket_',
		mutationPrefix: 'SOCKET_'
	}
}))

//Vue.use(VueSocketIO, config.SOCKETIO_ISYSTEM.DEV, store)

Vue.config.productionTip = false

router.beforeResolve((to, from, next) => {
	switch (to.path) {
		case '/login':
		case '/unauthorized':
		case '/logout':
			store.commit('setInitialized', false)
			store.commit('setToken', null)
			next()
			break;
		case '/loading':
			store.commit('setHeadersAuthorization', localStorage.getItem('token'))
			next()
			break;
		default:
			if (localStorage.getItem('token') != null) {
				if (!store.getters.getInitialized) {
					let path = (localStorage.getItem('redirect') != to.path && localStorage.getItem('redirect') != null) ? localStorage.getItem('redirect') : to.path
					localStorage.setItem('redirect', path)
					next({ path: '/loading' })
				} else {
					store.commit('setHistory', { fullPath: to.fullPath, name: to.name, from: from.fullPath })
					next()
				}
			} else {
				localStorage.setItem('redirect', to.path)
				next({ path: '/unauthorized' })
			}
			break;
	}
})

new Vue({
	router,
	store,
	axios,
	render: h => h(App)
}).$mount('#app')